'use client';

import { Button, Sort } from '@sprd/sprd-component-kit/v2';
import { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';
import { AssortmentSearchParams } from '@/app/[abTest]/[locale]/(spreadshirt)/cyo/assortment/list/utility/validationSchema';
import { SortDrawer } from '@/components/Filters/SortDrawer';
import { useRouter } from '@/i18n/navigation';
import { DEFAULT_ALP_SORT } from '@/utility/constants';
import { getCYOListPageHrefArgs } from '@/utility/urls';

type CYOSortDrawerProps = {
  slug: string[];
  searchParams: AssortmentSearchParams;
};

export const CYOSortDrawer = ({ slug, searchParams }: CYOSortDrawerProps) => {
  const t = useTranslations();
  const router = useRouter();
  const [open, setOpen] = useState<boolean>(false);

  const applySort = useCallback(
    (sort: AssortmentListPageSort) => {
      setOpen(false);
      router.push(
        getCYOListPageHrefArgs({
          categorySlugs: slug,

          queryParams: {
            ...searchParams,
            sort: sort === DEFAULT_ALP_SORT ? undefined : sort,
          },
        })
      );
    },
    [router, searchParams, slug]
  );

  return (
    <>
      <Button
        className="border-none text-sm font-semibold"
        variant="invert"
        onClick={() => setOpen(true)}
        startIcon={<Sort className="size-6" />}
      >
        {t('filter.sort.sortBy')}
      </Button>
      <SortDrawer
        open={open}
        onClose={() => setOpen(false)}
        onChange={applySort}
        selectedOption={searchParams?.sort ?? DEFAULT_ALP_SORT}
        sortOptions={{
          weight: t('filter.sort.weight'),
          new: t('filter.sort.new'),
          price: t('filter.sort.price'),
          priceReverse: t('filter.sort.priceReverse'),
        }}
      />
    </>
  );
};
